// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "RedemptionPage__textCenter__u0KDH";
export const page = "RedemptionPage__page__l4K8n";
export const background = "RedemptionPage__background__UcYJG";
export const content = "RedemptionPage__content__gljzV";
export const subtitle = "RedemptionPage__subtitle__Elj1r font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const progressBar = "RedemptionPage__progressBar__y-+Is";
export const footer = "RedemptionPage__footer__0HSnm";